import { Box } from "@mui/material"

const TopFotterImg = () => {
  return (
    <Box
      height={92}
      width="100%"
      sx={theme => ({
        [theme.breakpoints.down(840)]: {
          height: 70,
        },
        [theme.breakpoints.down(640)]: {
          height: 50,
        },
      })}
    >
      <img
        src="/assets/images/footer_img.png"
        alt="footer-bg-color"
        width="100%"
        height="100%"
        style={{
          display: "block",
        }}
      />
    </Box>
  )
}
export default TopFotterImg
